import React from "react";

function Home() {
  return (
    <div className="container">
      <h1 id="titolo">Benvenuto su Ferio WEB</h1>
    </div>
  );
}

export default Home;
